import React from "react";

const fmt = (s) => { try { return new Date(s).toLocaleString("it-IT", { dateStyle: "short", timeStyle: "short" }); } catch { return s; } };

export const SimMovements = ({ items, me }) => (
  <div className="max-h-72 overflow-y-auto divide-y divide-border text-sm" data-testid="sim-movements">
    {items.length === 0 && <p className="py-2 text-muted-foreground" data-testid="sim-movements-empty">Nessun movimento.</p>}
    {items.map((m) => {
      const sign = me ? (m.to_id === me ? "+" : "−") : "";
      return <div key={m.id} className="py-2 flex flex-wrap items-center justify-between gap-2" data-testid={`sim-movement-${m.id}`}>
        <span className="min-w-0"><strong>{m.kind_label}</strong> · {m.from_name} → {m.to_name}{m.note ? ` · ${m.note}` : ""}
          <span className="block text-xs text-muted-foreground">{fmt(m.created_at)} · da {m.by_name}</span></span>
        <strong className={sign === "+" ? "text-emerald-600" : sign ? "text-amber-600" : ""}>{sign}{m.qty}</strong>
      </div>;
    })}
  </div>
);
